import { Art57Section } from "../../Art57Section/Art57Section";
import { Art57Node } from "../Art57Node/Art57Node";
import { BaseNode } from "../BaseNode";
import { environment } from "../../../../../environments/environment";
import { SectionService } from "../../../service/section-service/section-service";
import { MedicinalproductsService } from "../../../service/medicinalproducts-service/medicinalproducts.service";
import { TreeNodeXEVPRMMessage } from "../Art57Node/Entity/TreeNodeXEVPRMMessage";
import { AutoUploadNode } from "../AutoUploadNode";
import { MedicinalProductsQueryNode } from "./MedicinalProductsQueryNode";
import { Art57NodeUtils } from "../Art57Node/Art57NodeUtils";
import { Util } from "../../Util";
import { SectionName } from "../../SectionName";

export class MedicinalProductsNodeUtils {
    /**
     * 
     * @param parentNode Parent node where the new child is created
     * @param type New node type
     * @param createChildTemplateParams optional parameters required for some CreateChildTemplate in Art57Node
     */
    private static createNodeType(parentNode: BaseNode, createChildTemplateParams?: any): Art57Node {
        const newNode = (parentNode as Art57Node).createChildTemplate(createChildTemplateParams);
        return newNode![0];
    }

    private static retrieveLabel(item: any): any {
        let code: string = '';
        let codeLabel = "EV Code";
        if (item.hasOwnProperty('ev_Code') && item.ev_Code != null) {
            code = item.ev_Code;
        } else if (item.hasOwnProperty('atccode')) {
            code = item.atccode;
            codeLabel = "ATC Code";
        } else if (item.hasOwnProperty('value')) {
            code = item.value;
        }

        return { code: code, codeLabel: codeLabel };

    }


    static createXEVPRMNode(operation: number, nodeWithParams: any, model: any): void {

        if (nodeWithParams instanceof AutoUploadNode) {

            nodeWithParams.createChildTemplateParams["operationType"] = operation;

            if ((nodeWithParams.ioc!.get(Art57Section).productReports.treeView[0] as TreeNodeXEVPRMMessage).createXEVPRMNode(nodeWithParams.parentNodeClass!, Util.deepClone(nodeWithParams.datasource), operation, nodeWithParams.createChildTemplateParams)) {
                nodeWithParams.ioc!.get(SectionService).selectProductReportNode(nodeWithParams.ioc!.get(Art57Section).productReports.selectedNode);
            }

        } else if (nodeWithParams instanceof MedicinalProductsQueryNode) {
            if (model != undefined && model.length > 0) {

                let entityIds: number[] = [];

                const message = nodeWithParams.ioc!.get(TreeNodeXEVPRMMessage);
                const nodeList: BaseNode | null =
                    Art57NodeUtils.findFirstChildNodeOfType(message, nodeWithParams!.parentNodeClass!) as BaseNode | null;

                model.forEach((item: any) => {

                    let code: string;
                    if (item.hasOwnProperty('atccode')){
                        code = item.atccode;
                    }else{
                        code = item.ev_Code
                    }

                    if (operation===1 || !nodeList || !message.entityExist(nodeList, code)) {
                        let codeLabel = this.retrieveLabel(item);
                        let errorMessage = { message: `The operation cannot be perfomed on entity with ${codeLabel.codeLabel} ${codeLabel.code}` };
                        if (Art57NodeUtils.nodeCanBeLoaded(nodeWithParams.ioc!, operation, item, errorMessage)) {
                            entityIds.push(item.id);
                        } else {
                            nodeWithParams.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: errorMessage.message, life: environment.warningElapsedTime });
                        }
                    }
                });

                if (entityIds.length > 0) {

                    nodeWithParams.ioc!.get(MedicinalproductsService).loadEntities(nodeWithParams.autoUploadEntityName!, entityIds)
                        .subscribe({
                            next: (data: any) => {

                                data.forEach((item: any) => {
                                    const jsonData = item;
                                    if (jsonData) {
                                        nodeWithParams.createChildTemplateParams["operationType"] = operation;
                                        (nodeWithParams.ioc!.get(Art57Section).productReports.treeView[0] as TreeNodeXEVPRMMessage).createXEVPRMNode(nodeWithParams!.parentNodeClass!, jsonData, operation, nodeWithParams.createChildTemplateParams);
                                    }
                                });
                                nodeWithParams.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: "Entities added to the EVPRM message", life: environment.successElapsedTime});
                                nodeWithParams.ioc!.get(SectionService).selectProductReportNode(nodeWithParams.ioc!.get(Art57Section).productReports.selectedNode);
                            },
                            error: (error: any) => {
                                nodeWithParams.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                            }
                        });

                }

            }
        }
    }

    static loadEntities(entities: any, entityNode: any) {
        entities.forEach((item: any) => {
            entityNode!.addChild(item);
            const newChild = entityNode.children.find((child: any) => child.data.model.id === item.id);
            entityNode.ioc!.get(SectionService).selectMedicinalProductsNode(newChild);
        });

    }

}